module.exports = __webpack_public_path__ + "static/media/mh.8711b04d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mh.svg
// module id = 188
// module chunks = 0